import { RichText } from "components/RichTextWidget";
import { Container, Heading6 } from "shared/components";

import styles from "./Content056.module.scss";

export const Hero056 = ({ payload }) => {
  const title = payload?.title ?? "";
  const description = payload?.description ?? "";

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.block}>
          <Heading6 className={styles.title} color="dark">
            {title}
          </Heading6>
          <RichText
            value={description}
            color="dark"
            className={styles.description}
          />
        </div>
      </Container>
    </div>
  );
};

export default Hero056;
